import React from "react";
import { Box, Button, Container, Grid, Typography, Stack } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { Map } from "@mui/icons-material";

const HeroSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: { xs: 8, md: 12 }, // Add padding for different screen sizes
        minHeight: { xs: 'auto', md: '70vh' }, // Adjust height
        background: 'linear-gradient(to left, #43595e, #27373b)',
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5} alignItems="center">
          {/* Left Content */}
          <Grid item xs={12} md={7}>
            <Typography
              variant="h2"
              component="h1" // More semantic for a page title
              sx={{
                fontWeight: "bold",
                color: "#12db69", // Bright green color from image
                fontSize: { xs: '2.5rem', sm: '3rem', md: '3.75rem' },
                lineHeight: 1.2,
              }}
            >
              Meet the rigorous demands of ECO4 energy efficiency programmes
            </Typography>

            <Typography sx={{ mt: 3, fontSize: '1.125rem', opacity: 0.9 }}>
              We offer outsourced manpower and compliance support for ECO4 retrofit projects
            </Typography>
          </Grid>

          {/* Right Content - Contact Card */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                backgroundColor: "white",
                color: "#2D3748", // Dark text color
                borderRadius: '16px',
                p: 4,
                boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                Ask us for
              </Typography>
              <Typography sx={{ mb: 0.5 }}>• Sample audit packs</Typography>
              <Typography sx={{ mb: 0.5 }}>• Rate cards by region</Typography>
              <Typography sx={{ mb: 3 }}>• Project rollout plans</Typography>

              <Stack spacing={2}>

                <Button
                  variant="contained"
                  startIcon={<PhoneIcon />}
                  fullWidth
                  component="a"
                  href="tel:07568540041"
                  sx={{
                    backgroundColor: "#12db69",
                    color: "white",
                    fontWeight: "bold",
                    py: 1.5,
                    fontSize: '1rem',
                    borderRadius: '12px',
                    textTransform: "none",
                    justifyContent: 'flex-start',
                    px: 2,
                    '&:hover': {
                      backgroundColor: "#52c578",
                    },
                  }}
                >
                  07568540041
                </Button>
                <Button
                  variant="contained"
                  startIcon={<EmailIcon />}
                  fullWidth
                  component="a"
                  href="mailto:info@ibraqservices.co.uk"
                  sx={{
                    backgroundColor: "#12db69",
                    color: "white",
                    fontWeight: "bold",
                    py: 1.5,
                    fontSize: '1rem',
                    borderRadius: '12px',
                    textTransform: "none",
                    justifyContent: 'flex-start',
                    px: 2,
                    '&:hover': {
                      backgroundColor: "#52c578",
                    },
                  }}
                >
                  info@ibraqservices.co.uk
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Map />}
                  fullWidth
                  component="a"
                  href="https://maps.app.goo.gl/LJSodoEqKvPAeA4U8"
                  sx={{
                    backgroundColor: "#12db69",
                    color: "white",
                    fontWeight: "bold",
                    py: 1.5,
                    fontSize: '1rem',
                    borderRadius: '12px',
                    textTransform: "none",
                    justifyContent: 'flex-start',
                    px: 2,
                    '&:hover': {
                      backgroundColor: "#52c578",
                    },
                  }}
                >
                  OF-5, Unit 1, Nimbus Park, Porz Avenue, Dunstable, Bedfordshire,LU5 5WZ
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;